var _defs, _g, _g2, _g3, _g4, _g5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContractDetailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Ico Custom Contract Detail",
    viewBox: "0 0 67 94.119",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".contract-detail-icon{fill:currentColor}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(38.272 9.762)",
    "data-name": "Pfad 13648"
  }, /*#__PURE__*/React.createElement("path", {
    className: "contract-detail-icon",
    transform: "translate(-560.05 -207.59)",
    d: "m569.9 217.43a4.92 4.92 0 1 0-4.924-4.92 4.92 4.92 0 0 0 4.921 4.92zm0 2.46c-3.287 0-9.848 1.648-9.848 4.92v2.46h19.7v-2.46c-2e-3 -3.272-6.563-4.92-9.852-4.92z",
    "data-name": "Pfad 13649"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 25697"
  }, /*#__PURE__*/React.createElement("path", {
    className: "contract-detail-icon",
    transform: "translate(-35.14 -59.86)",
    d: "M99.953 59.86H63.504l-.036.005-.034.005-.039.009-.03.008-.037.013-.031.011-.033.015-.032.015-.03.018-.031.019-.031.023-.027.02a.458.458 0 0 0-.046.042l-.007.006-27.706 27.687-.007.008a.897.897 0 0 0-.041.046l-.022.029-.021.028-.021.034-.016.027-.017.035-.014.03-.013.034-.012.033c-.004.011-.006.023-.009.035l-.008.034c-.002.011 0 .027-.006.041s0 .02 0 .03v63.594a2.189 2.189 0 0 0 2.187 2.186h62.619a2.189 2.189 0 0 0 2.187-2.186V62.045a2.189 2.189 0 0 0-2.187-2.185zm-36.122 1.5a.729.729 0 0 1 .474.682v26.229a.73.73 0 0 1-.729.728H37.327a.73.73 0 0 1-.682-.474zm36.851 90.43a.73.73 0 0 1-.729.729H37.327a.73.73 0 0 1-.729-.729V90.331a2.18 2.18 0 0 0 .729.125h26.249a2.189 2.189 0 0 0 2.187-2.185V62.045a2.173 2.173 0 0 0-.125-.729h34.315a.73.73 0 0 1 .729.729z",
    "data-name": "Pfad 13650"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.02 63.476)",
    "data-name": "Gruppe 25698"
  }, /*#__PURE__*/React.createElement("path", {
    className: "contract-detail-icon",
    d: "M0 0h43.747v1.457H0z",
    "data-name": "Rechteck 135227"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.02 71.883)",
    "data-name": "Gruppe 25699"
  }, /*#__PURE__*/React.createElement("path", {
    className: "contract-detail-icon",
    d: "M0 0h43.747v1.457H0z",
    "data-name": "Rechteck 135228"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.02 80.391)",
    "data-name": "Gruppe 25700"
  }, /*#__PURE__*/React.createElement("path", {
    className: "contract-detail-icon",
    d: "M0 0h43.747v1.457H0z",
    "data-name": "Rechteck 135229"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContractDetailIcon);
export default __webpack_public_path__ + "static/media/contractDetailIcon.4444422b8bf55638632ad6608e51273d.svg";
export { ForwardRef as ReactComponent };